// Brand assets (Checkpoint 5.37). ONE resolver, shared by the signed-out landing (splash.js) and the World
// Tour header (tourscreen.js), so the wordmark can never drift between the two screens.
//
// Matched by STEM, not by exact filename — the same discipline as the audio clips (5.29). The file on disk is
// `logo-PrettyGolf1.png`; a re-export to `logo-PrettyGolf2.png` must not silently blank the brand. The glob
// lives INSIDE the function (never at module top level) and we return the resolved, hashed URL VALUE, never
// the source-path key (the 4.14.2 lesson).
//
// Returns '' when absent. Both callers degrade to the text wordmark rather than rendering a broken image —
// a missing asset must never leave the landing page with no name on it.
export function logoUrl() {
  const urls = import.meta.glob('../static/brand/*.png', { eager: true, query: '?url', import: 'default' });
  const key = Object.keys(urls).find((k) => /\/logo-prettygolf\d*\.png$/i.test(k));
  return key ? urls[key] : '';
}
